import React from 'react';
import Select from 'react-select';

export default function ModalSelect({ className = '', styles = {}, placeholder = 'Sélectionner…', ...props }) {
  const menuPortal = styles.menuPortal;

  return (
    <Select
      {...props}
      className={`ae-shared-modal-select ${className}`.trim()}
      classNamePrefix="ae-select"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      menuPlacement="auto"
      menuShouldScrollIntoView={false}
      placeholder={placeholder}
      noOptionsMessage={() => 'Aucun résultat'}
      styles={{
        ...styles,
        menuPortal: (base) => ({
          ...base,
          ...(menuPortal ? menuPortal(base) : {}),
          zIndex: 1600,
        }),
      }}
    />
  );
}
